/* global _E, DOC, Element, dinStyle, Q, nf, body, SS, MAIN, TE, EP, edit_switch */

// styling attributes for the element that will pop

last_shup_zIndex = 1000;
shupper =
{
    ease: "ding",
    background: "rgba(255,255,221,1)",
    color: "black",
    fontSize: ".9em",
    show: function (ev) {
        if (ev.currentTarget.poper)
            return; /// ??? kill current and make new        

        var
            elm = ev.currentTarget,
            X = elm.x;//.offsetLeft,
        Y = elm.y;//.offsetTop,
        opt = ev.options || {},
            text_in = opt.info || elm.info || elm.getA("info") || opt.text || '',
            type = opt.type || (elm.hasA('shup', 'panel') ? 'panel' : 'bubble');

        last_shup_zIndex++;
        var poper = _E('').css("white-space:pre-wrap;position:absolute;z-index:" + last_shup_zIndex + ";height:0;opacity:0;" + if_brac('transform') + ":scale(0);");
        elm.poper = poper;
        poper.source = elm;
        poper.setA('escDie');

        if (elm.poper_z_index) {
            poper.style.zIndex = elm.poper_z_index;
        }
        elm.fire("shuped")


        var but = _E('kill').css("margin:0;position:absolute;right:0;z-index:1;color:black");
        but.on("click", function (ev) {
            ev.stopPropagation();
            poper.die(.2);
            elm.poper = null;
        });
        poper._(but);



        var bol = _E().css(
            "background:" + (opt.background || shupper.background) +
            ";color:" + (opt.color || shupper.color) +
            ";font-size:" + shupper.fontSize +
            ";" + (opt.css ? opt.css : "") +
            (opt.css || "")
        );
        if (opt.attr) {
            bol.setA(opt.attr.s2o);
        }

        elm.hasA('shup', 'as_text') ? bol._(_txt(text_in)) : bol.innerHTML = text_in;
        poper._(bol);
        poper.content = bol;
        if (opt.relative) {
            elm._(poper);
        }
        else {
            document.body._top(poper); // a  must for offsets calculations

        }


        //BUBBLE
        if (type !== 'panel') {
            bol.setA('shup_bubble').css(opt.shup_style);
            var ar = _E().css("width:14px;height:14px;position:absolute;left:-7px");
            ar.style.background = bol.style.background;
            ar.style.borderTop = ar.style.borderRight = bol.computed('border');
            poper._(ar);
            //poper.style.width=poper.offsetWidth+'px';// block browser reshaping

            // LEFT/RIGHT
            if (elm.hasA("shup", "side|left|right") || ["side", "left", "right"].has(opt.place)) {
                var left = X + elm.offsetWidth + 10;
                poper.style.left = left + 'px';
                ar.style.top = "1.5em";
                poper.style.top = (Y - 15) + "px";
                var dR = DOC.clientWidth - left - poper.offsetWidth;
                if ((dR < 0 || elm.hasA("shup", "left") || opt.place === 'left') && !(elm.hasA("shup", "right") || opt.place === 'right')) {// horizontal flip
                    poper.style.left = X - poper.offsetWidth - 10 + "px";
                    ar.style.left = poper.offsetWidth - 7 + "px";
                    ar.rotate(45);
                }
                else {
                    ar.rotate(-135);
                }
            }
            // TOP/BOTTOM
            else {
                poper.style.left = X + elm.w / 2 + "px"; // obiectul poper pune  indicatorul pe mijlocul elementului target
                bol.style.left = -Math.max(30, bol.w / 6) + 'px'; // panelul mult spre dreapta 
                var dR = DOC.clientWidth - bol.x - bol.w;
                if (dR < 0) {
                    bol.tmpA("_anm_");
                    bol.style.left = -(bol.offsetWidth * 5 / 6) + 'px'; // panelul mult spre dreapta 
                    // !!!BAC>>> ciudat ca bol.w nu e bine masurat  de aceea folosesc .offsetWidth 
                }


                but.style.right = -parseInt(bol.style.left) + "px";

                // vertical flip ( default above ) 
                var dTop = elm.y - scrollY - bol.offsetHeight - 17;
                if ((dTop >= 0 || elm.hasA("shup", "top") || opt.place === 'top') && !(elm.hasA("shup", "bottom") || opt.place === 'bottom')) {// default show above
                    poper.style.top = Y + 'px';
                    but.style.top = bol.style.top = -bol.offsetHeight - 10 + 'px';
                    ar.style.top = '-17px';
                    ar.rotate(135);
                    ar.style.borderBottomLeftRadius = "1em"
                }
                else {// show bellow				
                    poper.style.top = (Y + elm.offsetHeight) + 'px';
                    but.style.top = bol.style.top = '9px';
                    ar.style.top = '2px';
                    ar.rotate(-45);
                }

            }
        }
        // PANEL default bottom with margin right observed
        else {
            bol.setA('shup_panel');

            //bol.style.width=bol.computed('width');
            var dx = DOC.clientWidth + pageXOffset - elm.x - bol.offsetWidth;
            poper.style.left = dx < 0 ? X + dx + 'px' : X + "px";
            var dTop = elm.y - pageYOffset - bol.offsetHeight;
            if (dTop > 0) {
                poper.style.top = (Y - bol.offsetHeight) + "px";
            }
            else {
                poper.style.top = (Y + elm.offsetHeight) + "px";
            }
        }



        if (opt.relative) {
            poper.style.left = (opt.relative.left || 0);
            poper.style.top = (opt.relative.top || 0);
        }



        if (elm.hasA("killable", 0) || opt.killable === false)
            but.die();


        poper.fade(1).morf("transform", "scale(1)", '.2', function () {
            poper.runx();
        }, shupper.ease);
        if (opt.time) {
            setTimeout(function () {
                poper.die(.5);
                elm.poper = null;
            }, opt.time < 10 ? opt.time * 1000 : opt.time);
        }
        return poper;
    },
    kill: function (ev) {
        var elm = ev.currentTarget;
        try {
            if (elm.hasA("shup", "static") || elm.hasA("killable", 0))
                return;
            elm.poper.die(.2);
            elm.poper = null;
        } catch (err) {
            //console.log(err);
        }

    },
    config: function (elm, opt) {
        //                elm.on("t2m");
        elm.on("mousedown", shupper.show, true);
        elm.on("mouseup mouseout", shupper.kill);
        if (gettype(opt) === "Object") {
            for (var v in opt)
                elm.setA(v, opt[v]);
        }
        if (!elm.hasA("shup", "*_deco"))
            elm.setA("shup", "default_deco");
        elm.setA("noselect");

    }
};

Element.prototype.shupify = function (opt) {
    shupper.config(this, opt);
    return this;
};

/**
 * 
 * opt = {
 *          info:'html text here',
 *          place:["top (default)","bottom","left","right"],
 *          time: 1000 dft
 *      } 
 * 
 */
Element.prototype.shup = function (opt) {
    return shupper.show({ currentTarget: this, options: opt });
    //return this;
};


shup_input_error = function (inp, str, opt) {
    inp.scroll2view();
    inp.tmpA("spark").shup({ info: str, time: 2 }.tail(opt));
    return inp;
};






/************ INJECT info  FROM DEDICATED XML/json ***************************************/

// page automatic: <span info> text </span>

//
// 
//function install_shups($,file_adr){
//	function injectInfo(){
//		if($.block_info==undefined)return;	
//		all=$.querySelectorAll('[info]');
//		all.map(
//		function(e){
//			e.info=$.block_info[e.innerHTML.trim()]
//			e.shup();
//			}
//		)
//	}	
//	var col={};
//	if(file_adr)
//	Q.ajax(file_adr,function(x){
//		var titles=Q('title',x);
//		titles.map(
//			function(e){
//			var data='';
//			var N=e.parentNode.childNodes;
//			for(var i=0;i<N.length;i++){if(N[i].nodeType==4)data+=N[i].nodeValue}
//			try{col[e.firstChild.nodeValue]=data}catch(e){}
//			});
//		$.block_info=col;
//		injectInfo();
//		},'xml');
//	else 
//	injectInfo();
//} 
// 
//Element.prototype.shupify=function(file_adr){install_shups(this,file_adr)}
//
//

EP.show_error = function (text, time, place) {
    let $ = this;


    if (text instanceof Promise) {
        return text.then(rez => {
            this.show_error(rez, time, place);
        });
    }
    if (time === undefined || time === null) {
        // 0 means do not die
        time = 1.5;
    }
    let CH = new Chain;
    this.scroll2view();
    setTimeout(() => { // tre sa las scroll2view sa se randeze 
        $.tmpA("spark").shup({
            info: "<icon style='color:red;font-size:2em;transform:translate(-1px,1px)'>warning</icon> " + text,
            time: time,
            place: place,
            color: "navy",
            //css: ";font-family:monospace;",
            attr: "show_error:1",
        });
        CH.resolve($)
    }, 1);
    return CH;
};

let CCP; // current confirm popper
window.clear_confirm_poper = function () {
    if (CCP) { // sterg anterior ??  sau scroll_to_view
        CCP.source.poper = null;
        CCP.die(-1);
        CCP = null;
    }
};
EP.confirm = function (o = { text: 'hei', ok: nf, init: nf, append: false }) {  // nu merge cu o.init pt strica alinierea  
    clear_confirm_poper();
    let ch = new Chain();
    var OK = _E("<div btn='ok' style='position:relative;margin-right:1em;margin-bottom:.5em;padding:.3em .8em;'>OK</div>"),
        CANCEL = _E("<div btn='cancel' style='padding:.3em .8em;margin-bottom:.5em;'>CANCEL</div>");
    var elm = this;
    elm.show_error(o.text + "<hr style='opacity:.7;width:200%;margin-left:-5em !important;border:none;border-top:.7px solid #999'>" + OK.outerHTML + CANCEL.outerHTML, 0, o.place || "right").then((elm) => {
        CCP = elm.poper;
        o.init && o.init.bind(elm)(CCP.content);
        if (o.append) {
            elm._(CCP)
        }
        OK._oust(CCP.find("[btn='ok']", 1));
        CANCEL._oust(CCP.find("[btn='cancel']", 1));
    });



    OK.on("click", function (ev) { // tebuie sa intoarca 0 sau false ca sa continue altfel este error 
        if (!!o.ok) {
            var fail = o.ok(elm, o);
            Promise.all([fail]).then((x) => {
                let msg = x[0];
                if (msg && msg != '{}') {
                    if (!parseInt(msg)) {
                        OK.show_error(msg, 4000); // afishez textul error sau silent daca am primit 1 sau un nummar 
                    }
                } else {
                    clear_confirm_poper();
                    ch.resolve(true);
                }
            });
            return;
        }
        clear_confirm_poper();
        ch.resolve(true);
    });
    CANCEL.on('click', function () {
        clear_confirm_poper();
        ch.resolve(false);
    });
    return ch;
}



var DN_Z_INDEX_UP = 111000;

//NOTICER
/** 
* @means "document notice"
 * @example  <caption>basic</caption> 
 * let panel = dn("a_str", "tit", 3.2);// panel will die in 3.2 s
 * // add content after popup
 * panel.content._("<h1>bum</h1>");
 * @tutorial_link {@link  https://fo.myadr.ro/it/dcm/pops.php myadr.tutorial } 
 * 
 * @param {str} text . 
 * @param {str} title  
 * @param {float} time  0 or null means is endless
 * @returns {DIV} \<div escdie notice_panel>...<\div>
*/

{
    window.dn = function (text, title, time, htmlCode = false) {
        var panel = _E("<div notice_panel escdie></div>");
        panel.css("top:" + ((pageYOffset) + window.innerHeight / 5 + Math.random() * 150) + "px;left:" + ((pageXOffset) + window.innerWidth / 5 + Math.random() * 150) + "px;box-shadow:0px 0px 15px white;");
        var but = _E('kill').css("position:relative;float:right");
        but.on("pointerdown", function (e) {
            panel.die(-1);
        }, true);
        var mag = _E("m").setA("magnetic_btn_switch");
        mag.on("click", toggle_magnetic);
        panel.mag = mag;
        var lever = _E('<div dn_lever></div>');
        lever._(but, mag)._("<div dn_title style='color:#FF9;letter-spacing:1px;'>" + (title || '') + "</div>");
        panel.header = lever.last;
        panel.content = htmlCode ? _E("<div text_wrapper><div>" + text.replaceAll('<', '&lt').replaceAll('>', '&gt') + "</div></div>") : _E("<div text_wrapper><div>" + text + "</div></div>");
        panel._(lever)._(panel.content);
        let x = _E("x-dom-link");
        x.disconnected = () => {
            panel.fire("closed");
        }
        x.connected = () => {
            panel.fire("opened");
        }
        panel._(x);

        document.body._(panel);
        //panel.css("width:" + panel.computed("width")); // to prevent wrapping on edge touch
        panel.style.opacity = 1;
        lever.dragParent();
        setTimeout(function () {
            panel.run();
        }, 10);
        if (parseFloat(time)) {
            setTimeout(function () {
                panel.die(1);
            }, time);
        }
        panel.lever = lever;
        panel.rsz_elm = _E().css("position:absolute;width:100%;bottom:0;height:0");
        let btn = _E().css(a_css);
        panel.rsz_elm._(btn);
        panel._(panel.rsz_elm);
        btn.on('pointerdown', activate_reshape.bind(panel), false);
        panel.on("pointerdown", jump_up);
        lever.on("pointerdown", jump_up.bind(panel));
        panel.z = ++DN_Z_INDEX_UP;
        return panel;
    }

    function jump_up(ev) {
        let p = this;
        if (p.z < DN_Z_INDEX_UP) {
            DN_Z_INDEX_UP++;
            p.z = DN_Z_INDEX_UP;
        }
        //console.log(DN_Z_INDEX_UP);
    }
    function toggle_magnetic(ev) {
        let mag_btn = ev.target;
        let panel = mag_btn.parent.parent;
        let $ = panel;

        mag_btn.togA("active");
        let isMagnetic = mag_btn.hasA("active");

        if (isMagnetic) {
            $.css({
                position: "fixed",
                top: parseInt($.y - window.scrollY) + "px",
                left: parseInt($.x - window.scrollX) + "px",
                transform: "translate(0px,0px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale(1) skew(0deg)"
            });
        } else {
            $.css({
                position: "absolute",
                top: 0,
                left: 0,
                transform: "translate(" + parseInt($.x) + "px," + parseInt($.y) + "px) rotateX(0deg) rotateY(0deg) rotateZ(0deg) scale(1) skew(0deg)"
            });
        }
    }


    let activate_reshape = function (e) {
        var panel = this, target = panel.content;
        e.stopImmediatePropagation();// prevent hendlers overlaping
        reshapeData = {// record state before reshaping
            'mXo': e.clientX,
            'mYo': e.clientY,
            'width': target.w,
            'height': target.h,
            target
        };
        if (!target.resizable_ready) {
            //            console.log(target.cr)
            target.style.width = target.w + "px";
            target.style.height = target.h + "px";
            target.css("max-width:none;max-height:none");
            target.resizable_ready = true;
        }

        document.onselectstart = function () {
            return false;
        };//prevent selections for IE
        e.preventDefault();// prevent selections for FF
        document.on('pointermove', throttled_reshape_dn_panel);
        document.once("pointerup", ev => {
            document.off('pointermove', throttled_reshape_dn_panel);
            document.onselectstart = null;
        })
    }

    let reshapeData;

    let throttled_reshape_dn_panel = ((ev) => {
        var o = reshapeData;
        var tg = o.target;
        var dx = ev.clientX - o.mXo;
        var dy = ev.clientY - o.mYo;
        tg.w = o.width + dx
        tg.h = o.height + dy
        // let min = o.target.parent.lever.w
        // if (o.width + dx < min) {
        //     tg.w = min;
        // }
    }).throttle(20);

    let a_css = `background: rgba(255,255,255, 0.1);
    width: 1em;
    height: 1em;
    cursor: pointer;
    float: right;
    transform: translate(10%,-90%);
    touch-action: none;`;







    let NOMENCLATORS = {}
    /**
     * 
     * @param {*} tb_name 
     */
    dn.show_nomenclator = function (tb_name, tg = null, opt = {}) {
        if (!NOMENCLATORS[tb_name]) {
            ask("db\\read.val", { tb_name: tb_name, limit: "300" }, function (r) {
                NOMENCLATORS[tb_name] = r.parsed;
                tg ? tg.click() : dn.show_nomenclator(tb_name);
            });
        } else {
            var D = NOMENCLATORS[tb_name];
            var panel = dn(D.to_table(1).setA("smart").outerHTML, "<m bc>NOMENCLATOR</m> " + tb_name.split(".").pop());
            panel.content.style.paddingTop = 0;
            var tbl = panel.find("table[simple]", 1), trh = tbl.tHead.rows[0];
            tbl.scroll_size = 450;
            trh.on("click", function order_by_column(ev) {
                var ckth = ev.target, ord_prop, ord_desc;
                trh.cells.map(th => {
                    if (th !== ckth) {
                        th.remA("desc");
                    } else {
                        if (+th.getA("desc") || !th.hasA("desc")) {
                            th.setAttribute("desc", "0");
                            ord_desc = false;
                        } else {
                            th.setAttribute("desc", "1");
                            ord_desc = true;
                        }
                        ord_prop = th.getA("c_name");
                        var tb2 = D.order_by(ord_prop, ord_desc).to_table(1);
                        tb2.tBodies[0].oust(tbl.tBodies[0]);
                    }
                });

            });
            if (opt.cb) {
                opt.args ? opt.cb(...opt.args) : opt.cb();
            }
        }
    };


    var nd_panel = _E();
    dn.nmcld = function (data = [], opt = {}) {
        if (nd_panel) {
            nd_panel.die(-1);
        }
        var D = Array.isArray(data) ? data : [], title = "NOMENCLATOR" + (opt.title ? " <m bc>" + opt.title + "</m>" : "");

        nd_panel = panel = dn(D.to_table(1).setA("nomenclator").setA("smart").outerHTML, title);
        panel.lever._top(_E('a', '<icon style="color:white;font-weight:100">download</icon>').on("click", function (ev) { // this = ev.target -- am functie normala nu arrow 
            this.download = title + ".csv";
            this.href = 'data:text/csv; charset=utf-8,' + encodeURIComponent("\uFEFF" + D.dump_csv(1));
        }).css("margin-left:.5em;min-width:1em").setA({ title: 'CSV' }));

        var tbl = panel.find("table[simple]", 1),
            trh = tbl.tHead.rows[0];
        tbl.scroll_size = 450;
        trh.on("click", function order_by_column(ev) {
            finder.value = "";
            var ckth = ev.target,
                ord_prop,
                ord_desc;
            trh.cells.map((th) => {
                if (th !== ckth) {
                    th.remA("desc");
                } else {
                    if (+th.getA("desc") || !th.hasA("desc")) {
                        th.setAttribute("desc", "0");
                        ord_desc = false;
                    } else {
                        th.setAttribute("desc", "1");
                        ord_desc = true;
                    }
                    ord_prop = th.getA("c_name");
                    var tb2 = D.order_by(ord_prop, ord_desc).to_table(1);
                    tb2.tBodies[0].oust(tbl.tBodies[0]);
                }
            });
        });
        /* find in nomenclator */
        var finder = _E('input')
            .setA("nomen_finder")
            .css(`min-height: 0;background:#333;color:white;margin: 0 0 0 .5em;width: 4em;padding: 0 .3em;font-size: .9em;outline:none`)
            .on("keyup", (ev) => {
                var rgx = new RegExp(ev.target.value.replace(/\s/g, ".*"), "gims");
                D.map((s, i) => {
                    let see = false, V = Object.values(s);
                    for (let j = 0; j < V.length; j++) {
                        if (rgx.test(V[j])) {
                            see = true;
                            break;
                        }
                    }
                    tbl.rows[i + 1].hidden = !see;
                });
            })
        panel.lever._top(finder);


    }

}








Element.prototype.notice = function (txt) {
    var $ = this, a;
    // prevent double noticing
    if ($.noticer)
        return $;
    // make notice_panel
    var p = _E("<div notice_panel escdie></div>");
    p.source = $;
    var but = _E('kill').css("margin:0;position:absolute;right:0;z-index:1");
    but.on("click", function () {
        p.die();
        delete $.noticer;
    }, true);
    var txt = txt || $.info || $.getA("notice");
    p._(but)._("<div text_wrapper><div style='padding-right:1em'>" + txt + "</div></div>");
    // tunning position
    var dx = 0, dy = 0, s = '';
    if (a = arguments[1]) {
        switch (true) {
            case typeof a === 'object':
                {
                    dx = parseInt(a[0]) || 0;
                    dy = parseInt(a[1]) || 0;
                }
                ;
                break;
            case a === 'right':
                {
                    dx = $.offsetWidth;
                    dy = -$.offsetHeight;
                }
                break;
            case a === 'top':
                {
                    dy = -$.offsetHeight;
                }
                break;
            default:
                s = a;
        }
    }
    // insert into DOM 
    p._after($);
    p.css(s + ";" +
        "left:" + ($.offsetLeft + dx) + "px;" +
        "top:" + ($.offsetTop + $.offsetHeight + dy) + 'px;'
    );
    //$.setA('noticed');
    $.noticer = p;
    p.style.opacity = 1;
    p.drag();
    return $;
};



var current_confirm_panel;
function aha_confirm(o) {
    if (current_confirm_panel) {
        current_confirm_panel.setA("hidden");
        current_confirm_panel.die();
    }

    var ch = Chain(this);
    var panel = dn(o.text || o.html, o.title || "CONFIRM").css("min-width:30em;_max-width:30em"),
        OK = _E("<div btn style='position:relative;float:right;margin-right:1em;padding:.3em .5em;_background:white;border:none;_font-weight:bold'>&nbsp; OK &nbsp;</div>"),
        CANCEL = _E("<div class='btn' style='float:right;padding:.3em .8em;_background:white;border:none;_font-weight:bold'>CANCEL</div>");
    panel._(_E().css("border-top:1px solid rgba(255,255,255,.4);padding:1em;min-width:15em;")._(CANCEL, OK, "<div style='clear:both'></div>")).setA("confirm");
    current_confirm_panel = panel;
    o.tail({ dom: { OK, CANCEL, panel } });
    aha_confirm.env = {
        panel: panel,
        content: panel.content,
        ok_btn: OK,
        cancel_btn: CANCEL
    };
    o.init && o.init(panel.content);
    CANCEL.on('click', function () {
        current_confirm_panel = null;
        panel.die();
        !!o.cancel && o.cancel(o);
        ch.resolve(false);
    });
    function close_ok() {
        current_confirm_panel = null;
        panel.die();
        ch.resolve(true);
    }
    OK.on("click", function (ev) {
        if (!!o.ok) { // daca am functie 
            var REZ = o.ok(panel, o); // return-ul funtia ok()
            if (REZ) {
                if (REZ instanceof Promise) {  // {ok: async ()=>{    ... await ... } } // sincronizez ask 
                    REZ.then(() => {
                        close_ok();
                    })
                    return;
                }
                if (!parseInt(REZ)) { // daca nu e numeric afishez erroare de mesaj altfel e silent stop on error
                    OK.show_error(REZ, 3000);
                    setTimeout(() => {
                        OK.poper && OK.poper.css({ "z-index": 1000000 });
                    }, 10);
                }
                return;
            }
        }
        close_ok();
    });
    if (typeof o.cb === 'function') {
        o.cb(o);
    }
    panel.OK = OK;
    panel.CANCEL = CANCEL;

    if (o.dcm) {
        console.log(o.dcm)
        let help_btn = _E('icon', "help").css("font-size:1.3em;font-weight:200;cursor:pointer;color:#bdf;line-height:0;vertical-align:middle;transform:translate(-10px,.8em);");
        var v = _E("x-view").setA({ href: o.dcm.href });
        if (o.dcm.title) {
            v.setA({ view_title: o.dcm.title })
        }
        help_btn.on("click", () => {
            v.click();
        });
        help_btn._before(CANCEL)
        aha_confirm.env.help = help_btn;
    }
    return ch;
};





// DOCX DOWNLOAD
aha_confirm_print = function (opt) { // interface , project , save_as, reuse
    opt = opt || {};
    opt.title = opt.title || "DOWNLOAD";
    var print_opt = {
        interface: opt.interface,
        project: opt.project,
        save_as: opt.save_as || '',
        reuse: opt.reuse || 0,
        action: opt.action || '',
        pre: opt.pre || null,
        use_printer: opt.use_printer || null,
        data: opt.data || null
    };
    opt.ok = function () {
        aha_print(print_opt);
    };
    aha_confirm(opt);
};
/**
 * prompt for parameters for execute smth 
 
 * @param {type} o
 * @returns {undefined} */
aha_execute = function (o) {
    var ch = Chain(this);
    var panel = dn(o.text, o.title || "").css("min-width:20em;max-width:30em"),
        SELECT = _E("select"),
        RUN = _E('<div run="" id="prj_mng_run"></div>');

    panel._(_E().css("border-top:1px solid rgba(255,255,255,.4);padding:1em;min-width:15em;")._(SELECT, RUN, "<div style='clear:both'></div>")).setA("aha_execute_panel");

};

// press esc to wipe any notice panel visible	
function killPops() {
    Q('[escdie]').map(
        function (e) {
            try {
                delete e.source.noticer;
                e.source.poper = null;

            } catch (err) {
            }
            var attr_val = e.getAttribute('escdie');
            eval(attr_val);
            e.on_die && e.on_die();
            e.die(-1);
        });
}

function collapse(elm) {
    elm.fade(0).resizeH(0).resizeW(0);
}
function expand(elm, f, w, h) {
    elm.fade(f).resizeH(h).resizeW(w);
}
function collapseAll() {
    var elm = Q('[collapse]');
    for (var i = 0; i < elm.length; i++)
        collapse(elm[i]);
}




// use ESC to close all pops and collapse all colapsable
window.addEventListener('keyup',
    function (e) {
        if (e.code === "Escape" || +e.which === 27 || e.key === "Escape") {
            killPops();
        }
    }, false);
//window.addEventListener('click',collapseAll,false);



EP.popup_show = function (o = {}) {
    if (this.poper) {
        return this.poper;
    }
    this.poper = _E('<span  escdie class="popuptext show" id="myPopup"></span>');
    this.poper.html = o.text || '';
    this.poper.setAttribute("style", o.style || '');
    o.bg_color && this.poper.setA(o.bg_color);
    this._top(this.poper);
    this.poper.source = this;
    this.setA("popuped");
    o.time && setTimeout(() => {
        this.popup_hide(o);
    }, o.time);
    return this.poper;
};
EP.popup_hide = function (o) {
    this.poper && this.poper.die(.3);
    this.poper = null;
    this.remA("popuped");
};






// GSHUP  
// ---  global_show_up ----  <gshup><m>text_intreg</m></gshup> .... in css am gshup::after{ content:'...'}
document.addEventListener('mousedown', function show_gshup(ev) {
    var tg = ev.target;
    if (tg.tagName === 'GSHUP') {
        document.gshup_poper = tg.shup({ info: tg.first.html });
    }
    if (tg.tagName === 'IDIOM' && tg.hasA("info")) {
        document.gshup_poper = tg.shup({ info: ((tg.querySelector('info') || _E()).html).trim() });
    }
});
document.addEventListener('mouseup', function hide_gshup(ev) {
    if (document.gshup_poper) {
        setTimeout(
            function () {
                if (document.gshup_poper) {
                    document.gshup_poper.source.poper = null;
                    if (!ev.altKey) {
                        document.gshup_poper.die();
                    }
                }
                document.gshup_poper = null;
            },
            0
        );
    }
});
document.addEventListener("click", function gshup_stop_propagation(ev) {
    if (ev.target.tagName === 'GSHUP') {
        ev.stopPropagation();
    }
}, true);





// BLINDER

/* EX
 Blinder.show(
 {
 title:"BAU",
 ok:()=>{if(cond){return "ERROR_TEXT"} else return false;},
 cancel:nf,
 html:"<div><input /></div>", 
 init:function(_i){
 _i.find('input')[0].value="TRALALA"
 },
 hint:'text to help '
 }
 )
 * */

(function () {
    var $ = _E().setA("BLINDER_OBJECT").setC("modal");
    window.Blinder = $;

    // STRUCTURE
    $.header = _E('div').setA({ id: "modalHeader" }).css("padding:.5em;color:initial")._(
        $.flag = _E().css("float:left"),
        $.kill = _E("kill").css("float:right;font-size:2em;color:navy;line-height: 1em;width: 1.3em;"),
        $.modal_title = _E().setA({ id: "modalTitle" })
    );
    $.content = _E('div').setA({ id: "modalBody" }).css("padding:0");

    $.footer = _E('div').setA({ id: "modalFooter" }).css("_float:right")._(
        $.apply_btn = _E('div', "APPLY").setA({ btn: '', hidden: '', apply_btn: '', tabindex: "0" }).css("float:left;margin-right:.5em;position:relative"),
        $.ok_btn = _E('div', "OK").setA({ btn: '', hidden: '', ok_btn: '', tabindex: "0" }).css("float:left;margin-right:.5em;position:relative"),
        $.cancel_btn = _E('div', "CANCEL").setA({ btn: '', hidden: '', cancel_btn: '', tabindex: "0" }).css("float:left;position:relative;margin-right:3em"),
        $.export_btn = _E('div', "Export").setA({ btn: '', hidden: '', export_btn: '', tabindex: "0" }).css("float:left;position:relative;margin-right:3em"),
        $.undo_btn = _E('div').setA({ btn: '', hidden: '', undo_btn: '', tabindex: "0", title: "UNDO" }).css("float:left;position:relative;margin-right:.5em"),
        $.redo_btn = _E('div').setA({ btn: '', hidden: '', redo_btn: '', tabindex: "0", title: "REDO" }).css("float:left;position:relative"),
        $.hint_btn = _E('div', "i").setA({ letter_btn: '', _hidden: '', tabindex: "0" }).css("border-radius:1em;").css("float:right;position:relative;color:initial;font-size:1.3em;line-height:1em;bottom:-1em;right:-.8em;padding:.2em !important;font-weight: bold;"),
        $.info_div = _E('div').css("color: gray; font-family: monospace; font-size: .8em; float: right; margin-top: .5em;")
    );
    $.frame = _E('div').setA("modal_content")._($.header, $.content, _E().css("clear:both"), $.footer, _E().css("clear:both"));
    $._($.frame);
    // EVENTS
    $.kill.on("click", function (ev) {
        if (ev.which === 27 || ev.code === "Escape" || ev.isTrusted) {  // fortez interogarea funtiei cancel --- poateå veni in kill si din tasta ESC
            $.cancel_btn.click();
        }
        else {
            Blinder.hide();
        }
    });
    $.on("dblclick", function (ev) {
        if ($ === ev.target && !session.changes) {
            ev.preventDefault();
            $.cancel_btn.click();
            document.onselectstart = function () {
                return false;
            };
        }
    });
    $.hint_btn.on("click", ev => {
        dn($.hint_btn.data, "BLINDER HINT");
    });
    ["ok", "apply", "cancel", "export", "undo", "redo"].map(s => {
        let btn = $[s + "_btn"];
        btn.on("click,keypress", ev => {
            if (btn.hasA("disabled")) {
                return;
            }
            if (btn.poper) {
                btn.poper.die(-1);
                btn.poper = null;
            }
            let error = ($.conf[s] || nf)(ev); // fiecare btn are un rezolver care intoarce sau nu o valoare 
            if (s === "undo" || s === "redo") {
                return;
            }

            if (!error) { // 0 sau "" empty string or false
                $.kill.fire("click", { source: btn, btn: s });
            }
            else {
                if (error instanceof Promise) {
                    error.then((response) => {
                        if (!response) {
                            $.kill.fire("click", { source: btn, btn: s });
                        }
                        else {
                            if (response != 1 && response != true) { // 1 si true pt silent reject
                                btn.shup({ info: response, relative: { left: "1em" } });;
                            }
                        }
                    }).catch(reject => {
                        btn.shup({ info: reject, relative: { left: "1em" } });
                    });
                }
                else {
                    if (error != 1 && error != true) { // 1 si true pt silent reject
                        btn.shup({ info: error, relative: { left: "1em" } });;
                    }
                }
            }

        });
    });

    Object.defineProperties($, {
        title: {
            set: function (str) {
                this.modal_title.html = str || '';
            }
        },
        show: {
            value: function (O = {}) {
                var $ = this;
                $.style.zIndex = ++window.top_z_index;

                $.style.paddingTop = '' // resetare la default din css
                !$.assisted && $.assist(); // 1 time configuration 
                this.conf = O;
                var rename = { ok: "OK", apply: "APPLY", cancel: "CANCEL", export: "Export", undo: " < ", redo: " > " }.tail(O.rename_btn || {});
                ["ok", "apply", "cancel", "export", "undo", "redo"].map(s => {
                    var btn = this[s + "_btn"];
                    if (btn) {
                        btn.remA("disabled"); // resetare butoane daca au fost folosite in alt scope
                        btn[O[s] ? "remA" : "setA"]("hidden");
                        btn.html = rename[s];
                    }
                });
                this.flag._clr(O.flag || _E());
                this.title = O.title;
                this.content._clr(O.html || _E()); // O.html poate fi _E('m')  sau "<m>...</m>"    !!! ATENTIE ---  pt cazul _E('m') am referinta deci daca afectez continutul o fac pe original  
                if (O.hint) {
                    this.hint_btn.remA("hidden").data = O.hint;
                } else {
                    this.hint_btn.setA("hidden");
                }
                $.close_cb = O.close_cb || nf;
                requestAnimationFrame(() => {
                    var _i = this.content.first;
                    if (!_i) {
                        _i = _E('div', this.content.html);
                        this.content._clr(_i);
                    }
                    _i.init();
                    _i.run();
                    (O.init || nf).bind($)(_i);
                    $.fire("blinder.up");
                });
                this.style.display = 'block';
                document.body.setA("blinded", "not-menu");
                this.active = true;
                return this;
            }
        },
        hide: {
            value: function () {
                if (this.active) {
                    ["ok", "apply", "cancel", "export", "undo", "redo"].map(s => {
                        let poper = this[s + "_btn"].poper;
                        if (poper) {
                            this[s + "_btn"].poper = null;
                            poper.die(-1);
                        }
                    });
                    $.reset_editing();
                    $.fade(0, .2, function () {
                        this.content.html = '';
                        this.info_div.html = '';
                        this.style.display = 'none';
                        document.body.remA("blinded");
                        document.onselectstart = null;
                        this.active = false;
                        $.css("opacity:1");
                        $.fire("blinder.down");
                    });
                    this.close_cb();
                    this.close_cb = nf;
                    // overlay views
                    {
                        if (allViews.length) {

                            allViews.map(view => {

                                //view_placing_reference._(view.frame);
                            });

                        }
                    }
                }
            }
        },
        lock: {
            get: function () { },
            set: function (x) {
                x = Q.bool(x);
                this[x ? "on" : "off"]("click", block_click, true);
                this[x ? "setA" : "remA"]("locked");
            }
        },
        _i: {
            get: function () {
                return this.content.first;
            },
            enumerable: true
        },
        assist: {
            value: function () {
                var $ = this;
                $.AST = new input_assistant($);
                $.AST.surface = $.frame;
                $.AST.lister = new Lister($.AST);
                $.AST.lister.frame.setA("escdie");
                $.AST.set_lister = new SetLister($.AST);
                $.AST.calendar = new Calendar($.AST);
                $._($.AST.frame);
                $.assisted = true;
            }
        },
        changes: {
            get: () => Q.bool(SS.blinder_changes),
            set: (v) => SS.blinder_changes = !!v
        },
        cursor: {
            get: () => +SS.blinder_cursor || 0,
            set: (v) => SS.blinder_cursor = (v || 0)
        },
        editing: {
            get: () => (SS.blinder_editing || '{}').parsed,
            set: (obj) => SS.blinder_editing = JSON.stringify(obj)
        },
        edited_data: {
            get: () => (SS.bed || '{}').parsed,
            set: (obj) => SS.bed = JSON.stringify(obj)
        },
        target: {
            get: () => MAIN.first.get_by_xpath(Blinder.editing.source)
        },
        stack: {
            get: () => (SS.blinder_stack || '[null]').parsed,
            set: (arr) => SS.blinder_stack = JSON.stringify(arr)
        },
        record: {// inregistreaza editarile in session.stack
            value: function (obj, override_last) {
                this.changes = true;
                var ss = this.stack.slice(0, this.cursor + (override_last ? 0 : 1));
                if (!ss.length) { // ???????????????
                    ss = [null];
                }
                //console.log(this.cursor, ss);
                ss.push(obj);
                this.stack = ss;
                return !override_last ? this.cursor++ : this.cursor;
            }
        },
        reset_editing: {
            value: function () {
                this.cursor = 0;
                this.stack = [null];
                this.changes = false;
                this.editing = null;
            }
        },
        check_state: {
            /*
             * daca vin din reload cu editare sau popstate si am editari nesalvate in blinder trebuie sa refac starea de editare a blinderului
             * in blinder nu se poate edita decait o singura tabela odata si numai daca vin din editul de MAIN
             * */
            value: function (ev) {
                if (this.changes) {
                    try {
                        var field = MAIN.first.get_by_xpath(Blinder.editing.source);
                        edit_switch.active = 1;
                        field.scroll2view();
                        field.tmpA("spark");
                        field && field.restore_state(ev);  // !!!BAC>>>  ex x-aim are metoda restore_state care  reface forma de editare in Blinder
                        // setTimeout(function () {
                        (field.show_btn || field.controller).click();
                        //console.log(field, Blinder.editing.source)
                        // }, 1);
                    } catch (e) {
                        console.log(e);
                        this.changes = false;
                    }
                }
            }
        },

        undo: {
            value: function () {
                this.undo_btn.click();
            }
        },
        redo: {
            value: function () {
                this.redo_btn.click();
            }
        }
    });

    function block_click(ev) {
        ev.stopImmediatePropagation();
        ev.preventDefault();
        ev.stopPropagation();
        return false;
    }
    //document.body._($);


    // dupa ce fac afisarea TE cu toate date  inclusiv X-FORM pot avea ceva editari in Blinder si trebuie sa refac starea de editare 
    document.on("completion", ev => {
        Blinder.check_state(ev);
    });

})();

/* attributes_click_reaction = {
    c2c: (elm) => { // copy to clipboard
        navigator.clipboard.writeText(elm.parent.parent.innerText);
        elm.tmpA("copied_in_clipboard");
    }
}
window.addEventListener("click", function react_on_attributes(ev) {
    for (attr in attributes_click_reaction) {
        ev.target.hasAttribute(attr) && attributes_click_reaction[attr](ev.target);
    }
}); */